<div class="limiter">
    <div class="container-login100">
    </div>
    <div class="wrap-login100">
        <form class="form-signin">
            <div>
                <img  class ="imageR360 " src="../../../assets/images/loginR360.jpg" alt="logo r360" width="200">
            </div>
            <router-outlet></router-outlet>
        </form>
    </div>
</div>
